"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressHelper = void 0;
const constants_1 = require("./constants");
class ProgressHelper {
    static preDeployProgress;
    static deployProgress;
    static scaffoldProgress;
    static async startScaffoldProgressHandler(ui, isAdd = false) {
        this.scaffoldProgress = ui?.createProgressBar(isAdd ? constants_1.ProgressTitleMessage.AddProgressTitle : constants_1.ProgressTitleMessage.ScaffoldProgressTitle, Object.entries(constants_1.ScaffoldProgressMessage).length);
        await this.scaffoldProgress?.start("");
        return this.scaffoldProgress;
    }
    static async endScaffoldProgress(success) {
        await this.scaffoldProgress?.end(success);
        this.scaffoldProgress = undefined;
    }
}
exports.ProgressHelper = ProgressHelper;
//# sourceMappingURL=progress-helper.js.map